// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__QmgEg","description":"MealItem_description__gcDam","price":"MealItem_price__fw3VZ"};